import { defineComponent as o, createBlock as c, openBlock as r, unref as l, mergeProps as p, withCtx as s, createElementVNode as e } from "vue";
import { RevIcon as u } from "@ds/components/Icon";
const i = /* @__PURE__ */ o({
  name: "IconRefund",
  __name: "IconRefund",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(n) {
    const a = n;
    return (d, t) => (r(), c(l(u), p(a, { "view-box": "0 0 24 24" }), {
      default: s(() => [...t[0] || (t[0] = [
        e("path", { d: "M2.25 12A9.75 9.75 0 0 1 12 2.25a9.72 9.72 0 0 1 6.75 2.714V3a.75.75 0 0 1 1.5 0v3.5A1.25 1.25 0 0 1 19 7.75h-3a.75.75 0 0 1 0-1.5h1.916l-.043-.044A8.25 8.25 0 1 0 12 20.25 8.25 8.25 0 0 0 20.25 12a.75.75 0 0 1 1.5 0c0 5.385-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12" }, null, -1),
        e("path", { d: "M12 11.5c2.21 0 4-.672 4-1.5s-1.79-1.5-4-1.5S8 9.172 8 10s1.79 1.5 4 1.5" }, null, -1),
        e("path", { d: "M15.092 11.763C14.264 12.073 13.17 12.25 12 12.25c-1.17 0-2.264-.177-3.092-.487a4.305 4.305 0 0 1-.644-.3C8.094 11.63 8 11.811 8 12c0 .829 1.79 1.5 4 1.5s4-.671 4-1.5c0-.19-.093-.37-.264-.537a4.307 4.307 0 0 1-.644.3" }, null, -1),
        e("path", { d: "M12 14.25c1.17 0 2.264-.177 3.092-.487a4.307 4.307 0 0 0 .644-.3C15.906 13.63 16 13.811 16 14c0 .829-1.79 1.5-4 1.5S8 14.83 8 14c0-.19.093-.37.264-.537a4.305 4.305 0 0 0 .644.3C9.736 14.073 10.83 14.25 12 14.25" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  i as default
};
